import React from 'react';
import styled from 'styled-components';
import {
  GenericInputProps,
  InputsLightTheme,
} from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { useDropdownInputUpdater } from '@/features/editor/widgets/custom-widget/inputs/shared/use-dropdown-updater';

const VALUE_KEY = `fontWeight`;

const options: DropdownInputOption[] = [
  { label: `Thin`, value: `100` },
  { label: `Ultra Light`, value: `200` },
  { label: `Light`, value: `300` },
  { label: `Normal`, value: `400` },
  { label: `Medium`, value: `500` },
  { label: `Semi Bold`, value: `600` },
  { label: `Bold`, value: `700` },
  { label: `Ultra Bold`, value: `800` },
  { label: `Heavy`, value: `900` },
];

export function FontWeightInput({
  customizationIdx,
  customization,
  componentIdx,
  component,
  specIdx,
  spec,
  device,
  initialValues,
  onValuesChanged,
}: GenericInputProps) {
  const { getValue, onChange, undoRedoCount } = useDropdownInputUpdater(
    {
      customizationIdx,
      customization,
      componentIdx,
      component,
      specIdx,
      spec,
      device,
      initialValues,
      onValuesChanged,
    },
    VALUE_KEY,
    options,
  );

  return (
    <Wrapper>
      <DropdownInput
        key={undoRedoCount}
        options={options}
        theme={InputsLightTheme}
        defaultValue={getValue()}
        onChange={onChange}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div``;
